import axios from "../config"

class MessageService{
    axios;
    constructor(){
        this.axios = axios;
    }

    getMessage(pageId,messageId,customerId,customerOrPage,replyId) {
        let url = `/message`
        return axios.get(url,{
            params:{
                pageId,messageId,customerId,customerOrPage,replyId
            }
        }).then(request => request.data);
    }
    addMessage(message) {
        let url = `/message`
        return axios.post(url,message).then(request => request.data);
    }
    deleteMessage(message,pageId,customerId) {
        let url = `/message/${message.messageId}/${pageId}/${customerId}`
        return axios.delete(url).then(request => request.data);
    }
    updateMessage(message) {
        let url = `/message/${message.messageId}`
        return axios.put(url,message).then(request => request.data);
    }
    saveMessagePhoto(formData,pageId,customerId,customerOrPage,localPosition,type){
        let url = `message/${pageId}/photo/${customerId}/${customerOrPage}/${localPosition}/${type}`;
        return axios.put(url, formData,
            {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }).then(request => request.data);
      }
      getMessageNextPre(messageId,pageId,nextpre,customerId) {
        let url = `/message/photo/${messageId}/${pageId}/${nextpre}/${customerId}`
        return axios.get(url).then(request => request.data);
    }
}

const service = new  MessageService();
export default service;